import { render, staticRenderFns } from "./ProductDetailTools.vue?vue&type=template&id=d41da972&scoped=true&"
import script from "./ProductDetailTools.vue?vue&type=script&lang=js&"
export * from "./ProductDetailTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41da972",
  null
  
)

export default component.exports